import Bowser from "bowser";

export const extractComplete = () => Bowser.parse(window.navigator.userAgent)


// WEBPACK FOOTER //
// ./src/utils/extractBrowserInfo.js